"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.switchEnv = exports.currentEnv = exports.Env = void 0;
var Env;
(function (Env) {
    Env["test"] = "test";
    Env["local"] = "local";
    Env["dev"] = "dev";
    Env["staging"] = "staging";
    Env["prod"] = "prod";
})(Env || (exports.Env = Env = {}));
const currentEnv = () => {
    const env = process.env.ENVIRONMENT || "";
    if (!(env in Env))
        throw new Error(`Unexpected environment: ${env}`);
    return Env[env];
};
exports.currentEnv = currentEnv;
function switchEnv(envs) {
    const env = (0, exports.currentEnv)();
    const res = envs[env];
    if (res === null)
        return null;
    return res();
}
exports.switchEnv = switchEnv;
//# sourceMappingURL=env.js.map